import { contact } from "@/content/site";
import { useSeo } from "@/lib/seo";

function Legal({ title, children, testid }) {
  return (
    <section className="wrap max-w-4xl pt-32 pb-20 md:pt-44" data-testid={testid}>
      <h1 className="display h-lg">{title}</h1>
      <div className="mt-12 space-y-10 leading-relaxed text-ink/85 [&_h2]:display [&_h2]:mb-3 [&_h2]:text-[1.7rem] [&_h2]:text-ink">{children}</div>
    </section>
  );
}

const Email = () => <a className="underline" href={`mailto:${contact.email}`}>{contact.email}</a>;

export function MentionsLegales() {
  useSeo({ title: "Mentions légales", description: "Mentions légales du site SANAA DESIGN STUDIO — Sanaa BAJJANA, EI, Toulouse.", path: "/mentions-legales" });
  return (
    <Legal title="Mentions légales" testid="legal-page">
      <div><h2>Éditrice du site</h2>
        <p>Sanaa BAJJANA, entrepreneur individuel (EI), nom commercial SANAA DESIGN STUDIO.</p>
        <p>SIRET : 750 629 404 00054</p>
        <p>Adresse : 9 rue des Paradoux, 31000 Toulouse</p>
        <p>E-mail : <Email /> — Téléphone : <a className="underline" href={`tel:${contact.phoneIntl}`}>{contact.phone}</a></p>
      </div>
      <div><h2>Directrice de la publication</h2><p>Sanaa BAJJANA</p></div>
      <div><h2>Hébergeur</h2><p>Emergent Labs, Inc., 255 California Street, Suite 550, San Francisco, CA 94111, États-Unis.</p></div>
      <div><h2>Propriété intellectuelle</h2><p>Les contenus du site (textes, mise en page, logo, visuels) sont protégés. Toute reproduction sans autorisation est interdite.</p></div>
      <div><h2>Responsabilité</h2><p>Les informations du site sont fournies à titre indicatif. Aucune position dans les moteurs de recherche ni aucun volume de clients ne sont garantis.</p></div>
    </Legal>
  );
}

export function Confidentialite() {
  useSeo({ title: "Politique de confidentialité", description: "Politique de confidentialité et gestion des données personnelles du site SANAA DESIGN STUDIO.", path: "/politique-de-confidentialite" });
  return (
    <Legal title="Politique de confidentialité" testid="privacy-page">
      <div><h2>Responsable du traitement</h2><p>Sanaa BAJJANA, EI — SANAA DESIGN STUDIO, 9 rue des Paradoux, 31000 Toulouse — <Email />.</p></div>
      <div><h2>Données collectées</h2><p>Via les formulaires de contact et de diagnostic : nom, entreprise, secteur, ville, e-mail, téléphone (facultatif), site et fiche Google (facultatifs), objectifs et message.</p></div>
      <div><h2>Finalité et base légale</h2><p>Ces données servent uniquement à répondre à votre demande et à préparer un éventuel devis. Le traitement repose sur votre consentement, recueilli lors de l'envoi, et sur les mesures précontractuelles prises à votre demande.</p></div>
      <div><h2>Destinataires</h2><p>Les données sont destinées à SANAA DESIGN STUDIO uniquement. Elles sont transmises par e-mail et conservées dans un espace d'administration sécurisé. Elles ne sont ni vendues ni cédées.</p></div>
      <div><h2>Durée de conservation</h2><p>Les demandes sans suite sont conservées au maximum 3 ans après le dernier contact, puis supprimées.</p></div>
      <div><h2>Cookies</h2><p>Le site n'utilise pas de cookies non essentiels par défaut. Si une mesure d'audience est activée, elle n'est chargée qu'après votre accord.</p></div>
      <div><h2>Vos droits</h2><p>Accès, rectification, effacement, opposition, limitation, portabilité : écrivez à <Email />. Vous pouvez aussi saisir la CNIL (cnil.fr).</p></div>
    </Legal>
  );
}
